var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotemarksIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 93,
    viewBox: "0 0 136 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.424 30.7779C135.424 13.7795 121.644 0 104.646 0C87.6476 0 73.8681 13.7795 73.8681 30.7779C73.8681 47.5679 87.3179 61.2089 104.028 61.5401C96.2577 69.1609 85.6149 73.8676 73.8681 73.8676V92.3344C107.863 92.3344 135.424 64.7733 135.424 30.7779ZM-4.57764e-05 92.3338C33.9953 92.3338 61.5558 64.7733 61.5558 30.7779C61.5558 13.7795 47.7753 0 30.7779 0C13.7795 0 -4.57764e-05 13.7795 -4.57764e-05 30.7779C-4.57764e-05 47.5679 13.4498 61.2089 30.1602 61.5401C22.3896 69.1609 11.7457 73.8676 -4.57764e-05 73.8676V92.3338Z",
    fill: "#00525E",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotemarksIcon);
export default __webpack_public_path__ + "static/media/quotemarks_icon.0a562740defd9dd6ec3cc71b787aab5b.svg";
export { ForwardRef as ReactComponent };